import { render } from "./wallets_money_history.vue?vue&type=template&id=69aafcc4"
import script from "./wallets_money_history.vue?vue&type=script&lang=js"
export * from "./wallets_money_history.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__